import { isAfter, isBefore, isValid } from 'date-fns';

import { currentBuilderState } from '../builder.state';

export function checkRawDateParams(wasStart: boolean): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (
        wasStart &&
        isValid(vp.rawStartDate) &&
        isValid(vp.rawEndDate) &&
        isAfter(vp.rawStartDate, vp.rawEndDate)
    ) {
        vp.rawEndDate = new Date(vp.rawStartDate);
    }

    if (
        !wasStart &&
        isValid(vp.rawStartDate) &&
        isValid(vp.rawEndDate) &&
        isBefore(vp.rawEndDate, vp.rawStartDate)
    ) {
        vp.rawStartDate = new Date(vp.rawEndDate);
    }
}
